import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Financiar/TaxeModels.cs ----------

export type VatTreatmentType = 'Standard' | 'CotaRedusa' | 'TaxareInversa' | 'Scutit' | 'IntracomunitarUE' | 'Export'
export type PackagingMaterialCategory = 'Plastic' | 'HartieCarton' | 'Sticla' | 'Metal' | 'Lemn' | 'Altele'

export interface VatRate {
  id: string
  code: string
  name: string
  ratePercent: number
  treatmentType: VatTreatmentType
  effectiveFrom: string
  effectiveTo: string | null
  isActive: boolean
}

export interface SaveVatRatePayload {
  code: string
  name: string
  ratePercent: number
  treatmentType: VatTreatmentType
  effectiveFrom: string
  effectiveTo?: string | null
}

export interface PackagingTaxRate {
  id: string
  materialCategory: PackagingMaterialCategory
  ratePerKg: number
  currency: string
  effectiveFrom: string
  effectiveTo: string | null
  isActive: boolean
}

export interface SavePackagingTaxRatePayload {
  materialCategory: PackagingMaterialCategory
  ratePerKg: number
  currency: string
  effectiveFrom: string
  effectiveTo?: string | null
}

export const listVatRates = () => api.get<VatRate[]>('/financiar/taxe/cote-tva').then((r) => r.data)
export const createVatRate = (payload: SaveVatRatePayload) =>
  api.post<{ id: string }>('/financiar/taxe/cote-tva', payload).then((r) => r.data)
export const updateVatRate = (id: string, payload: SaveVatRatePayload) =>
  api.put(`/financiar/taxe/cote-tva/${id}`, payload)
export const deactivateVatRate = (id: string) => api.post(`/financiar/taxe/cote-tva/${id}/deactivate`)

export const listPackagingRates = () => api.get<PackagingTaxRate[]>('/financiar/taxe/taxa-ambalaje').then((r) => r.data)
export const createPackagingRate = (payload: SavePackagingTaxRatePayload) =>
  api.post<{ id: string }>('/financiar/taxe/taxa-ambalaje', payload).then((r) => r.data)
export const updatePackagingRate = (id: string, payload: SavePackagingTaxRatePayload) =>
  api.put(`/financiar/taxe/taxa-ambalaje/${id}`, payload)
export const deactivatePackagingRate = (id: string) => api.post(`/financiar/taxe/taxa-ambalaje/${id}/deactivate`)
